var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('Tabs',[_c('Tab',{attrs:{"title":"Pre Start"}},[_c('PreStart')],1),_c('Tab',{attrs:{"title":"Fitness Declaration"}},[_c('FitnessDeclarations')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }